var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCabinet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 6,
    width: 16,
    height: 12,
    rx: 1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 6v12"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 12h.01"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 12h.01"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7 18v2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17 18v2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCabinet);
export default __webpack_public_path__ + "static/media/cabinet.7018d5d025d1ac3654b443966ad584df.svg";
export { ForwardRef as ReactComponent };